import { helper } from '@ember/component/helper';

import { camelize } from '@ember/string';

import strings from 'rise-ui/config/strings.js';

export default helper(function oneStringHelper(params) {
  for (let i = 0, len = params.length; i < len; i += 2) {
    if (params[i]) {
      const key = params[i + 1];
      return strings[key] ?? strings[camelize(key)];
    }
  }
});
